import { steps } from '../config/componentConfig.json';
import { lazy } from 'react';
import { sortArrayOfObjects } from './stringHelper';
// import config from '../config/applicationConfig_hkbk.json';
// import configContext from './config';

//const logoImg =  applicationConfig().then( resp => {return resp.logo});
// {
//     const data = await applicationConfig();
//     console.log("Logo::", data.data.logo)
//     return data.data.logo;
// };  //"https://inazstgpfs3001.blob.core.windows.net/assets/logo.png"
/** -----------------------------------------------------------------------------------
 * Helper functions to Lazy Load Components using componentConfig.json
 *------------------------------------------------------------------------------------*/
// import component lazily
export const importComponent = (path) =>
  lazy(() =>
    import(`../../src/${path}`).catch(() =>
      console.log(`Error in importing component ${path}`)
    )
  );

// import material-ui component lazily
// export const importMaterialUIComponent = (path) =>
//   lazy(() =>
//     import(/* webpackMode: "eager" */ `@material-ui/${path}`).catch(() =>
//       console.log(`Error in importing component @material-ui/${path}`)
//     )
//   );

const components = steps.map((step) => {
  return step.components;
});

// load components lazily
export const loadLazyComponents = async (config) => {
  // lazy component state
  const lazyComponents = {};

  // get lazy components
  let lazyComps = {};
  const defaultComps = await components?.filter(
    (comp) => comp.default === true
  );
  defaultComps.forEach((comp) => (lazyComps[comp.type] = comp.component));

  if (config.components) {
    Object.entries(config.components).forEach(([key, value]) => {
      const lazyComp = components?.filter((comp) => comp.id === value);
      lazyComps[key] = lazyComp[0].component;
    });
  }

  // import components lazily
  Object.entries(lazyComps).forEach(([key, component]) => {
    const importComp = importComponent(component);
    lazyComponents[key] = importComp;
  });

  return lazyComponents;
};

//Stepper config

//getSteps
export const getStepperConfig = (config) => {
  const defaultSteps = steps?.filter((step) => step.required === true);
  let defaultStepWithDefaultComponet = [];
  defaultSteps.map((step) => {
    let obj = {};
    const reqSteps = step.components.filter((comp) => {
      if (comp.default === true) {
        obj = { ...step, components: comp };
        defaultStepWithDefaultComponet.push(obj);
      }
      return comp.default === true;
    })[0];
    return reqSteps;
  });
  // console.log('defaultSteps', defaultSteps);
  // console.log('defaultStepWithDefaultComponet', defaultStepWithDefaultComponet);

  if (config.stepperConfig?.steps) {
    let requiredSteps = [];
    const stepsFromConfig = sortArrayOfObjects(
      config.stepperConfig.steps,
      'stepNumber',
      'number'
    );
    stepsFromConfig.forEach((step, index) => {
      if (step.component) {
        //get matching step from componetconfig
        const matchingStep = steps.filter((comp) => {
          return comp.id === step.id;
        })[0];
        // console.log('matchingStep', matchingStep);

        let matchingComponent;
        //get matching componet from matched step
        if (matchingStep) {
          matchingComponent = matchingStep.components.filter((comp) => {
            return comp.id === step.component;
          })[0];
        }

        if (matchingComponent) {
          let object = {
            ...matchingStep,
            components: matchingComponent,
          };

          requiredSteps.push(object);
        }
      } else {
        //get default step
        let stepFromDefault = defaultSteps.filter((stp) => {
          return stp.id === step.id;
        });

        if (stepFromDefault) {
          //get default component from step components
          let componentToShow = stepFromDefault[0]?.components.filter(
            (comp) => {
              return comp.default === true;
            }
          )[0];
          let object = {
            ...stepFromDefault[0],
            components: componentToShow,
          };

          requiredSteps.push(object);
        }
      }
    });
    return requiredSteps;
  } else {
    return defaultStepWithDefaultComponet;
  }
};

//console.log('stepper config: ', getStepperConfig());
